import React, { createContext, useContext, useEffect, useState } from "react";
import { loadConfig } from "./configLoader";

const ConfigContext = createContext(null);

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const init = async () => {
      try {
        const cfg = await loadConfig();
        setConfig(cfg);
      } catch (e) {
        console.error("Failed to load config", e);
      } finally {
        setLoading(false);
      }
    };
    init();
  }, []);

  return (
    <ConfigContext.Provider value={{ config, loading }}>
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfig = () => useContext(ConfigContext);
